










import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import PriorityClazzCourseGroupCampusReportSearch from './search.vue';
import PriorityClazzCourseGroupCampusReportAction from './action.vue';
import PriorityClazzCourseGroupCampusReportTable from './table.vue';

import { Load } from '@/domains/system';

import { Now } from '@/domains/date';
import { Priority, PriorityType } from '@/domains/priority';
import { Supervisor } from '@/domains/supervisor';
import { Person, Profession } from '@/domains/person';
import { Campus } from '@/domains/campus';
import { Department } from '@/domains/department';
import { CourseGroup, CoursePlan } from '@/domains/course';
import { Page } from '@/domains/page';

@Component({
  name: 'PriorityClazzCourseGroupCampusReportPage',
  components: {
    PriorityClazzCourseGroupCampusReportSearch,
    PriorityClazzCourseGroupCampusReportAction,
    PriorityClazzCourseGroupCampusReportTable,
  },
})
export default class PriorityClazzCourseGroupCampusReportPage extends Vue {
  /** 加载 */
  @Prop()
  private load: Load;

  /** bus */
  @Prop()
  private bus: Vue;

  @Getter private now: Now;

  @Getter private supervisor: Supervisor;

  /** 表单 */
  private form: Priority = new Priority();

  /** 初始化表单 */
  private initForm(): void {
    const form: Priority = new Priority();
    const priorityType: PriorityType = new PriorityType();
    const clazz: CoursePlan = new CoursePlan();
    const clazzDepartment: Department = new Department();
    const clazzCourseGroup: CourseGroup = new CourseGroup();
    const page: Page = new Page();

    form.clazz = clazz;
    form.priorityOption = priorityType;
    form.pageInfo = page;
    clazz.department = clazzDepartment;
    clazzDepartment.courseGroup = clazzCourseGroup;

    form.enable = true;

    priorityType.year = this.now.year.year;
    priorityType.term = this.now.year.term;

    clazzCourseGroup.id = this.supervisor.courseGroup.id;

    this.form = form;
  }

  private created() {
    this.initForm();
  }

  private mounted() {
    this.bus.$on('priority-clazz-course-group-campus-report-initForm', () => { this.initForm(); });
  }
}
